import { Settings } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect } from "react";
import { useUsersApi } from "@/hooks/useUsersApi";
import { cn } from "@/lib/utils";

// Cache para almacenar el estado de admin
const adminCache = new Map<string, boolean>();

export default function NavbarItemSettings({
  expanded,
}: {
  expanded: boolean;
}) {
  const { user } = useAuth0();
  const { getUserByEmail } = useUsersApi();
  const [showSettings, setShowSettings] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkUserType = async () => {
      if (!user?.email) return;

      // Verificar si ya tenemos el resultado en caché
      if (adminCache.has(user.email)) {
        setShowSettings(adminCache.get(user.email)!);
        return;
      }

      try {
        const data = await getUserByEmail(user.email);
        const isAdmin = (data as any)?.userType === "admin";
        // Guardar en caché
        adminCache.set(user.email, isAdmin);
        setShowSettings(isAdmin);
      } catch (error) {
        console.error("Error checking user type:", error);
        setShowSettings(false);
      }
    };

    checkUserType();
  }, [user?.email, getUserByEmail]);

  if (!showSettings) return null;

  return (
    <Link
      to="/settings"
      className={cn(
        "flex items-center gap-1 h-10 rounded-xl px-3 transition-colors duration-200",
        "text-white/80 hover:text-white hover:bg-white/10",
        location.pathname === "/settings" && "bg-white text-[#141C25]",
        expanded ? "justify-start w-full" : "justify-center w-10 mx-auto",
        "focus:outline-none focus:ring-2 focus:ring-white/20",
      )}
      aria-current={location.pathname === "/settings" ? "page" : undefined}
    >
      <Settings size={22} className="flex-shrink-0" />
      {expanded && <span className="text-sm font-medium ml-2">Ajustes</span>}
    </Link>
  );
}
